<template>
    <div
        class="shop-renew-download fx-v-center fx-h-between"
        :class="{
            'download': isDownload,
            'shiyong': isDownload ? false : isShiYong,
            'biaozhun': isDownload ? false : isBiaoZhun,
            'zhuanye': isDownload ? false : isZhuanYe,
            'qijian': isDownload ? false : isQiJian
        }"
    >
        <div class="shop-renew-download__bg" />
        <div class="shop-renew-download__left fx-v-center">
            <div class="bg-icon" />
            <div v-if="isDownload" class="des color-333 ml-12">
                <h2 class="fw-600 fs-20 lh-20">下载中心</h2>
                <p class="fs-14 lh-20 mt-8">森果收银台/森果零售通</p>
            </div>
            <div class="des color-333 ml-12" v-else>
                <h2 v-if="isShiYong" class="fw-600 fs-20 lh-20">试用版</h2>
                <h2 v-if="isBiaoZhun" class="fw-600 fs-20 lh-20">标准版</h2>
                <h2 v-if="isZhuanYe" class="fw-600 fs-20 lh-20">专业版</h2>
                <h2 v-if="isQiJian" class="fw-600 fs-20 lh-20">旗舰版</h2>
                <p
                    v-if="shopInfo.remain_days >= 0"
                    class="fs-14 lh-20 mt-8"
                >{{ shopInfo.remain_days }}天后到期</p>
                <p v-else class="fs-14 lh-20 mt-8">已到期</p>
            </div>
        </div>
        <div v-if="isDownload" class="shop-renew-download__right btn" @click="toDownload">前往下载</div>
        <div
            v-else
            class="shop-renew-download__right btn"
            @click="toBuy"
        >{{ isShiYong ? '购买正式版' : '立即续费' }}</div>
    </div>
</template>

<script lang="ts">
import {
    createComponent,
    ref,
    onBeforeMount,
    onMounted,
    computed,
} from "@vue/composition-api";
import { editionJudge } from "../../../../utils/editionJudge";
import { useStore } from "../../../../store";
import domain from "@/config/domain";
import { openNewRenew } from "@/components/new_renew/new_renew.tsx";

export default createComponent({
    props: {
        isDownload: {
            type: Boolean,
            default: false,
        },
    },

    setup: (props, ctx) => {
        const store = useStore();

        const shopInfo = computed(() => {
            return (store.state as any).shop.shopInfo;
        });

        const isShiYong = computed(() => {
            return editionJudge.isShiYong;
        });

        const isBiaoZhun = computed(() => {
            return editionJudge.isBiaoZhun && !editionJudge.isShiYong;
        });

        const isZhuanYe = computed(() => {
            return editionJudge.isRealZhuanYe;
        });

        const isQiJian = computed(() => {
            return editionJudge.isQiJian;
        });

        function toDownload() {
            window.open(domain.cashier + "#/downloadNavigation");
        }

        function toBuy() {
            openNewRenew();
        }

        return {
            // data
            isShiYong,
            isBiaoZhun,
            isZhuanYe,
            isQiJian,
            shopInfo,
            // methods
            toDownload,
            toBuy,
        };
    },
});
</script>

<style lang="scss" scoped>
@mixin bgCommon() {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.shop-renew-download {
    position: relative;
    height: 80px;
    padding: 0 12px;
    background-color: #f7f7f7;

    &.download {
        .bg-icon {
            background-image: url("../images/download-icon.svg");
        }
    }

    &.shiyong {
        .shop-renew-download__bg {
            background-image: url("../images/shiyong-star.png");
        }

        .bg-icon {
            background-image: url("../images/shiyong.png");
        }

        .shop-renew-download__right {
            background: #009688;
        }
    }

    &.biaozhun {
        background-image: linear-gradient(90deg, #dbfdf4 0%, #ebfff6 100%);

        .shop-renew-download__bg {
            background-image: url("../images/biaozhun-star.png");
        }

        .bg-icon {
            background-image: url("../images/biaozhun.svg");
        }

        .shop-renew-download__right {
            background: #14cc9b;
        }
    }

    &.zhuanye {
        background-image: linear-gradient(270deg, #fff7e8 0%, #fff7e7 100%);

        .shop-renew-download__bg {
            background-image: url("../images/zhuanye-star.png");
        }

        .bg-icon {
            background-image: url("../images/zhuanye.svg");
        }

        .shop-renew-download__right {
            background: #efc377;
        }
    }

    &.qijian {
        background-image: linear-gradient(-44deg, #ffeadc 0%, #ffc29e 100%);

        .shop-renew-download__bg {
            background-image: url("../images/qijian-star.png");
        }

        .bg-icon {
            background-image: url("../images/qijian.svg");
        }

        .shop-renew-download__right {
            background-image: linear-gradient(-46deg, #65503e 0%, #2a2825 100%);
        }
    }

    &__bg {
        position: absolute;
        top: 0;
        right: 0;
        width: 208px;
        height: 80px;
        @include bgCommon();
    }

    &__left {
        .bg-icon {
            width: 40px;
            height: 40px;
            @include bgCommon();
        }
    }

    &__right {
        width: 120px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        background-color: #009688;
        border-radius: 3px;
    }
}
</style>
